import { Sparkle } from "lucide-react";

/**
 * UnseenDot — the rose pulse marker for "this is new since you last looked".
 *
 * DESIGN_CONTRACT §7 Awareness Contract. Drop this into a list row's
 * leftmost slot. Renders nothing if `unseen` is false so consumers can
 * always include it without conditional rendering.
 *
 * Visual: small rose dot with a slow pulse glow. Cyan is reserved for the
 * focus-scroll arrival flash (different meaning, different colour).
 */
export default function UnseenDot({ unseen, size = 8, label = "New", testId }) {
  if (!unseen) return null;
  return (
    <span
      className="hv-unseen-dot inline-flex items-center justify-center shrink-0"
      style={{ width: size, height: size }}
      aria-label={label}
      title={label}
      data-testid={testId || "unseen-dot"}
    >
      <Sparkle className="hidden" />
    </span>
  );
}
